
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-dashboard-bg">
      <div className="text-center space-y-6 animate-fade-in">
        <div className="h-20 w-20 mx-auto rounded-full bg-dashboard-card border border-dashboard-accent flex items-center justify-center">
          <AlertCircle className="h-10 w-10 text-dashboard-accent" />
        </div>
        
        <h1 className="text-4xl font-bold text-dashboard-accent">404</h1>
        <p className="text-xl text-dashboard-text-primary mb-4">Oops! Page not found</p>
        <p className="text-dashboard-text-secondary max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <Button asChild className="bg-dashboard-accent hover:bg-opacity-80 text-white mt-6">
          <a href="/">Return to Dashboard</a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
